export default "__VITE_ASSET__JzXC6SDz__"